export enum ExpectedPaymentErrorType {
  INVALID_CARD_DETAILS = 'INVALID_CARD_DETAILS',
  THREE_D_SECURE_CANCELLED = 'THREE_D_SECURE_CANCELLED',
}
